module.exports = __webpack_public_path__ + "static/media/35.115d2121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/35.jpg
// module id = 596
// module chunks = 0